// Typelizer digest 5197644263c780bf991aebb5b8a26547
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /learners/schools/:school_id/preference_templates */
  index: (
    params: { schoolId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/schools/:school_id/preference_templates', params, options),
    method: 'get',
  }),

  /** POST /learners/schools/:school_id/preference_templates */
  create: (
    params: { schoolId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/learners/schools/:school_id/preference_templates', params, options),
    method: 'post',
  }),

  /** GET /learners/schools/:school_id/preference_templates/new */
  new: (
    params: { schoolId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/schools/:school_id/preference_templates/new', params, options),
    method: 'get',
  }),

  /** GET /learners/schools/:school_id/preference_templates/:id/edit */
  edit: (
    params: { schoolId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/schools/:school_id/preference_templates/:id/edit', params, options),
    method: 'get',
  }),

  /** PATCH /learners/schools/:school_id/preference_templates/:id */
  update: (
    params: { schoolId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/learners/schools/:school_id/preference_templates/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /learners/schools/:school_id/preference_templates/:id */
  destroy: (
    params: { schoolId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/learners/schools/:school_id/preference_templates/:id', params, options),
    method: 'delete',
  }),
}
